import { render } from "./AddEtagerePage.vue?vue&type=template&id=aa024518&ts=true"
import script from "./AddEtagerePage.vue?vue&type=script&lang=ts"
export * from "./AddEtagerePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__